import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "../common_components/Layout";
import Home from "../pages/home/Home";
import About from "../pages/about/About";
import Contact from "../pages/Contact";
import Illustrations from "../pages/Illustrations";
import PrintProjects from "../pages/printprojects/PrintProjects";
import DigitalProjects from "../pages/DigitalProjects";

const MainRouter = () => {
  return (
    <Router>
      <div className="frame-container">
        {/* Frame Lines */}
        <div className="frame top"></div>
        <div className="frame bottom"></div>
        <div className="frame left"></div>
        <div className="frame right"></div>
        {/* Routes */}
        <Routes>
          <Route path="/" element={<Home />} /> 
          <Route element={<Layout />}>
            <Route path="about" element={<About />} />
            <Route path="contact" element={<Contact />} />
            <Route path="illustrations" element={<Illustrations />} />
            <Route path="print-projects" element={<PrintProjects />} />
            <Route path="digital-projects" element={<DigitalProjects />} />
          </Route>
        </Routes>
      </div>
    </Router>
  );
};

export default MainRouter;
